// Version : 0.0.1
// Author :AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AuditingToolActionTypes from './auditing-tool.types';
import {
	auditingToolListGet,
	auditingToolGet,
	questionnaireAllGet,
	trainingProposalMembersList,
	trainingProposalIndividualList,
	addtrainingProposalList,
	updatetrainingProposalList,
	deleteTrainingProposalList,
	getAllSuperviserList,
	approveTrainingProposalList,
	savePhysicalDocsForMember,
	saveDigitalDocsForMember,
	reAuditProposal,
	getMemberAuditAnswers,
} from './auditing-tool.service';

import {
	getAuditingToolDetailsSuccess,
	getAuditingToolDetailsFailure,
	getAuditingToolDetailsResponseChanged,
	fetchAuditingToolDetailsSuccess,
	fetchAuditingToolDetailsFailure,
	fetchAuditingToolDetailsChanged,
	getQuestionnaireSuccess,
	getQuestionnaireFailure,
	getQuestionnaireResponseChanged,
	getTrainingProposalMembersSuccess,
	getTrainingProposalMembersFailure,
	getTrainingProposalMembersChanged,
	getTrainingProposalIndividualSuccess,
	getTrainingProposalIndividualFailure,
	getTrainingProposalIndividualChanged,
	addTrainingProposalSuccess,
	addTrainingProposalFailure,
	addTrainingProposalChanged,
	updateTrainingProposalSuccess,
	updateTrainingProposalFailure,
	updateTrainingProposalChanged,
	deleteTrainingProposalSuccess,
	deleteTrainingProposalFailure,
	deleteTrainingProposalChanged,
	getAllSuperviserListSuccess,
	getAllSuperviserListFailure,
	getAllSuperviserListChanged,
	approveTrainingProposalSuccess,
	approveTrainingProposalFailure,
	approveTrainingProposalChanged,
	savePhysicalDocsSuccess,
	savePhysicalDocsFailure,
	savePhysicalDocsChanged,
	saveDigitalDocsSuccess,
	saveDigitalDocsFailure,
	saveDigitalDocsChanged,
	reAuditProposalSuccess,
	reAuditProposalFailure,
	reAuditProposalChanged,
	getMemberAuditAnswersSuccess,
	getMemberAuditAnswersFailure,
	getMemberAuditAnswersChanged,
} from './auditing-tool.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET AUDITING TOOL LIST DETAILS  ******************** */
export function* getAuditingToolList({ payload }: any) {
	try {
		const {
			companyID,
			officerID,
			branchID,
			centerID,
			groupID,
			limit,
			questionnaireID,
			searchData,
			status,
			userID,
			userLevel,
			databaseName,
		} = payload;
		const key = 'GetTrainingProposalListKey';
		const jsonData = {
			CompanyID: companyID,
			OfficerID: officerID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			Limit: limit,
			QuestionID: questionnaireID,
			SearchData: searchData,
			Status: status,
			UserID: userID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(auditingToolListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAuditingToolDetailsFailure(responseData.data));
		} else {
			yield put(getAuditingToolDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAuditingToolDetailsFailure(error));
	}
}

export function* resetGetAuditingToolListResponse() {
	yield put(getAuditingToolDetailsResponseChanged());
}

export function* onGetAuditingToolListDetails() {
	yield takeLatest(AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_START, getAuditingToolList);
}

export function* onGetAuditingToolListResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_RESPONSE_RESET,
		resetGetAuditingToolListResponse,
	);
}
/** *********************  END GET AUDITING TOOL LIST DETAILS ******************** */

/** *********************  START FETCH AUDITING TOOL DETAILS  ******************** */
export function* getAuditingToolDetails({ payload }: any) {
	try {
		const { companyID, userID, userLevel, databaseName, tempTrainingID } = payload;
		const key = 'GetTrainingProposalDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
			GroupTrainingProposalID: tempTrainingID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(auditingToolGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAuditingToolDetailsFailure(responseData.data));
		} else {
			yield put(fetchAuditingToolDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAuditingToolDetailsFailure(error));
	}
}

export function* resetGetAuditingToolDetailsResponse() {
	yield put(fetchAuditingToolDetailsChanged());
}

export function* onGetAuditingToolDetailsStart() {
	yield takeLatest(
		AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_START,
		getAuditingToolDetails,
	);
}

export function* onGetAuditingToolDetailsResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_RESET,
		resetGetAuditingToolDetailsResponse,
	);
}
/** *********************  END FETCH AUDITING TOOL DETAILS ******************** */

/** *********************  START GET OFFICER BASED ON BRANCH DETAILS  ******************** */
export function* getQuestionnaire({ payload }: any) {
	try {
		const { companyID, branchID, centerID, databaseName, userID, userLevel, userRole } =
			payload;
		const key = 'GetAllQuestionnaireListKey';
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(questionnaireAllGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getQuestionnaireFailure(responseData.data));
		} else {
			yield put(getQuestionnaireSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getQuestionnaireFailure(error));
	}
}

export function* resetGetQuestionnaireResponse() {
	yield put(getQuestionnaireResponseChanged());
}

export function* onGetQuestionnaireDetails() {
	yield takeLatest(AuditingToolActionTypes.GET_QUESTIONNAIRE_START, getQuestionnaire);
}

export function* onGetQuestionnaireResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.GET_QUESTIONNAIRE_RESPONSE_RESET,
		resetGetQuestionnaireResponse,
	);
}
/** *********************  END GET OFFICER BASED ON BRANCH LIST ******************** */

/** *********************  START TRAINING PROPOSAL MEMBERS  ******************** */
export function* getTrainingProposalMembersStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			userRole,
			branchID,
			centerID,
			groupID,
			isTrainingStarted,
			memberSearch,
			isTempTrainingID,
		} = payload;
		const key = 'GetAllTrainingMembersKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			IsTrainingStarted: isTrainingStarted,
			SearchMemberData: memberSearch,
			TrainingProposalID: isTempTrainingID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(trainingProposalMembersList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getTrainingProposalMembersFailure(responseData.data));
		} else {
			yield put(getTrainingProposalMembersSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getTrainingProposalMembersFailure(error));
	}
}

export function* resetTrainingProposalMembers() {
	yield put(getTrainingProposalMembersChanged());
}

export function* onGetTrainingProposalMembersDetails() {
	yield takeLatest(
		AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_START,
		getTrainingProposalMembersStart,
	);
}

export function* onGetTrainingProposalMembersResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_RESET,
		resetTrainingProposalMembers,
	);
}
/** *********************  END TRAINING PROPOSAL MEMBERS ******************** */

/** *********************  START TRAINING PROPOSAL INDIVIDUAL  ******************** */
export function* getTrainingProposalIndividualStart({ payload }: any) {
	try {
		const { companyID, databaseName, userID, groupTrainingID, groupDateTrainingID } = payload;
		const key = 'GetAllTrainingIndividualKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			GroupTrainingProposalID: groupTrainingID,
			GroupTrainingDateProposalID: groupDateTrainingID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(trainingProposalIndividualList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getTrainingProposalIndividualFailure(responseData.data));
		} else {
			yield put(getTrainingProposalIndividualSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getTrainingProposalIndividualFailure(error));
	}
}

export function* resetTrainingProposalIndividual() {
	yield put(getTrainingProposalIndividualChanged());
}

export function* onGetTrainingProposalIndividualDetails() {
	yield takeLatest(
		AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_START,
		getTrainingProposalIndividualStart,
	);
}

export function* onGetTrainingProposalIndividualResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_RESET,
		resetTrainingProposalIndividual,
	);
}
/** *********************  END TRAINING PROPOSAL MEMBERS ******************** */

/** *********************  START TRAINING PROPOSAL  ******************** */
export function* addTrainingProposalsStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			userRole,
			branchID,
			centerID,
			groupID,
			isCenterWise,
			proposalDate,
			meetupLatitude,
			meetupLongitude,
			meetupLocation,
			dateProposalArr,
			memberArr,
			provisionType,
		} = payload;
		const key = 'NewGroupTrainingProposalKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			TrainingType: isCenterWise ? 'Center' : 'Group',
			ProposedDate: proposalDate,
			ProposedBy: userID,
			MeetupLat: meetupLatitude,
			MeetupLong: meetupLongitude,
			MeetupAddress: meetupLocation,
			TrainingDateProposal: JSON.stringify(dateProposalArr).replace(/"/g, "'"),
			TrainingMembersArr: JSON.stringify(memberArr).replace(/"/g, "'"),
			ProvisionType: provisionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addtrainingProposalList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addTrainingProposalFailure(responseData.data));
		} else {
			yield put(addTrainingProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addTrainingProposalFailure(error));
	}
}

export function* resetTrainingProposalResponse() {
	yield put(addTrainingProposalChanged());
}

export function* onAddTrainingProposalDetails() {
	yield takeLatest(
		AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_START,
		addTrainingProposalsStart,
	);
}

export function* onAddTrainingProposalResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_RESET,
		resetTrainingProposalResponse,
	);
}
/** *********************  END TRAINING PROPOSAL ******************** */

/** *********************  START TRAINING PROPOSAL  ******************** */
export function* updateTrainingProposalsStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			userRole,
			branchID,
			centerID,
			groupID,
			isCenterWise,
			proposalDate,
			meetupLatitude,
			meetupLongitude,
			meetupLocation,
			dateProposalArr,
			memberArr,
			provisionType,
			isTempTrainingID,
		} = payload;
		const key = 'UpdateGroupTrainingProposalKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			GroupTrainingProposalID: isTempTrainingID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			TrainingType: isCenterWise ? 'Center' : 'Group',
			ProposedDate: proposalDate,
			ProposedBy: userID,
			MeetupLat: meetupLatitude,
			MeetupLong: meetupLongitude,
			MeetupAddress: meetupLocation,
			TrainingDateProposal: JSON.stringify(dateProposalArr).replace(/"/g, "'"),
			TrainingMembersArr: JSON.stringify(memberArr).replace(/"/g, "'"),
			ProvisionType: provisionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updatetrainingProposalList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateTrainingProposalFailure(responseData.data));
		} else {
			yield put(updateTrainingProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateTrainingProposalFailure(error));
	}
}

export function* resetUpdateTrainingProposalResponse() {
	yield put(updateTrainingProposalChanged());
}

export function* onUpdateTrainingProposalDetails() {
	yield takeLatest(
		AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_START,
		updateTrainingProposalsStart,
	);
}

export function* onUpdateTrainingProposalResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_RESET,
		resetUpdateTrainingProposalResponse,
	);
}
/** *********************  END TRAINING PROPOSAL ******************** */

/** *********************  START TRAINING PROPOSAL  ******************** */
export function* deleteTrainingProposalsStart({ payload }: any) {
	try {
		const { companyID, databaseName, userID, tempTrainingID } = payload;
		const key = 'DeleteGroupTrainingProposalKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			GroupTrainingProposalID: tempTrainingID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteTrainingProposalList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteTrainingProposalFailure(responseData.data));
		} else {
			yield put(deleteTrainingProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteTrainingProposalFailure(error));
	}
}

export function* resetDeleteTrainingProposalResponse() {
	yield put(deleteTrainingProposalChanged());
}

export function* onDeleteTrainingProposalDetails() {
	yield takeLatest(
		AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_START,
		deleteTrainingProposalsStart,
	);
}

export function* onDeleteTrainingProposalResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_RESET,
		resetDeleteTrainingProposalResponse,
	);
}
/** *********************  END TRAINING PROPOSAL ******************** */

/** *********************  START GET ALL SUPERVISER LIST  ******************** */
export function* getAllSuperviserListsStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			userRole,
			branchID,
			centerID,
			groupID,
		} = payload;
		const key = 'GetAllSuperviserListKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllSuperviserList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllSuperviserListFailure(responseData.data));
		} else {
			yield put(getAllSuperviserListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllSuperviserListFailure(error));
	}
}

export function* resetGetAllSuperviserListResponse() {
	yield put(getAllSuperviserListChanged());
}

export function* onGetAllSuperviserListDetails() {
	yield takeLatest(
		AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_START,
		getAllSuperviserListsStart,
	);
}

export function* onGetAllSuperviserListResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_RESET,
		resetGetAllSuperviserListResponse,
	);
}
/** *********************  END GET ALL SUPERVISER LIST ******************** */

/** *********************  START APPROVE TRAINING PROPOSAL  ******************** */
export function* approveTrainingProposalsStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			userRole,
			tempTrainingID,
			rejectModalValue,
			status,
		} = payload;
		const key = 'UpdateTraningProposalStatusKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			GroupTrainingProposalID: tempTrainingID,
			ApprovedStatus: status,
			RejectedReason: rejectModalValue,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(approveTrainingProposalList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(approveTrainingProposalFailure(responseData.data));
		} else {
			yield put(approveTrainingProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(approveTrainingProposalFailure(error));
	}
}

export function* resetRejectTrainingProposalResponse() {
	yield put(approveTrainingProposalChanged());
}

export function* onRejectTrainingProposalDetails() {
	yield takeLatest(
		AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_START,
		approveTrainingProposalsStart,
	);
}

export function* onRejectTrainingProposalResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_RESET,
		resetRejectTrainingProposalResponse,
	);
}
/** *********************  END APPROVE TRAINING PROPOSAL ******************** */

/** *********************  START SAVE PHYSICAL DOCS  ******************** */
export function* savePhysicalDocsStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			memberId,
			groupTrainingMemberID,
			groupTrainingProposalID,
			documents,
		} = payload;
		const key = 'SavePhysicalDocsForMemberKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			MemberID: memberId,
			GroupTrainingMemberID: groupTrainingMemberID,
			GroupTrainingProposalID: groupTrainingProposalID,
			PhysicalDocuments: JSON.stringify(documents).replace(/"/g, "'"),
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(savePhysicalDocsForMember, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(savePhysicalDocsFailure(responseData.data));
		} else {
			yield put(savePhysicalDocsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(savePhysicalDocsFailure(error));
	}
}

export function* resetSavePhysicalDocsResponse() {
	yield put(savePhysicalDocsChanged());
}

export function* onSavePhysicalDocsStart() {
	yield takeLatest(AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_START, savePhysicalDocsStart);
}

export function* onSavePhysicalDocsResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_RESET,
		resetSavePhysicalDocsResponse,
	);
}
/** *********************  END SAVE PHYSICAL DOCS ******************** */

/** *********************  START SAVE DIGITAL DOCS  ******************** */
export function* saveDigitalDocsStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			memberId,
			groupTrainingProposalID,
			documentType,
			verificationStatus,
			comments,
			verifiedBy,
			verifiedDate,
			verifications,
		} = payload;
		const key = 'SaveDigitalDocsForMemberKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberId,
			GroupTrainingProposalID: groupTrainingProposalID,
			DocumentType: documentType,
			VerificationStatus: verificationStatus,
			Comments: comments,
			verifiedBy: verifiedBy,
			VerifiedDate: verifiedDate,
			verifications: JSON.stringify(verifications).replace(/"/g, "'"),
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(saveDigitalDocsForMember, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(saveDigitalDocsFailure(responseData.data));
		} else {
			yield put(saveDigitalDocsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(saveDigitalDocsFailure(error));
	}
}

export function* resetSaveDigitalDocsResponse() {
	yield put(saveDigitalDocsChanged());
}

export function* onSaveDigitalDocsStart() {
	yield takeLatest(AuditingToolActionTypes.SAVE_DIGITAL_DOCS_START, saveDigitalDocsStart);
}

export function* onSaveDigitalDocsResponseReset() {
	yield takeLatest(AuditingToolActionTypes.SAVE_DIGITAL_DOCS_RESET, resetSaveDigitalDocsResponse);
}
/** *********************  END SAVE DIGITAL DOCS ******************** */

/** *********************  END SAVE DIGITAL DOCS ******************** */

/** *********************  START RE-AUDIT PROPOSAL  ******************** */
export function* reAuditProposalStart({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			trainingDateProposalID,
			trainingAnswerIDList,
			overallStaffRemarks,
			reauditOfficerDate,
			reAuditOfficerID,
			originalOfficerID,
		} = payload;
		const key = 'TrainingReAuditingKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			TrainingProposalID: trainingDateProposalID,
			TrainingDateProposalID: trainingDateProposalID,
			TrainingAnswerIDList: trainingAnswerIDList,
			Remarks: overallStaffRemarks,
			ReauditDate: reauditOfficerDate,
			ReAuditOfficer: reAuditOfficerID,
			OfficerID: originalOfficerID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(reAuditProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(reAuditProposalFailure(responseData.data));
		} else {
			yield put(reAuditProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(reAuditProposalFailure(error));
	}
}

export function* resetReAuditProposalResponse() {
	yield put(reAuditProposalChanged());
}

export function* onReAuditProposalStart() {
	yield takeLatest(AuditingToolActionTypes.RE_AUDIT_PROPOSAL_START, reAuditProposalStart);
}

export function* onReAuditProposalResponseReset() {
	yield takeLatest(AuditingToolActionTypes.RE_AUDIT_PROPOSAL_RESET, resetReAuditProposalResponse);
}
/** *********************  END RE-AUDIT PROPOSAL ******************** */

/** *********************  START GET MEMBER AUDIT ANSWERS  ******************** */
export function* getMemberAuditAnswersStart({ payload }: any) {
	try {
		const { companyID, databaseName, userID, memberID, groupTrainingProposalID } = payload;
		const key = 'MemberAuditFetchApproveKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			MemberID: memberID,
			GroupTrainingProposalID: groupTrainingProposalID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getMemberAuditAnswers, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberAuditAnswersFailure(responseData.data));
		} else {
			yield put(getMemberAuditAnswersSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberAuditAnswersFailure(error));
	}
}

export function* resetGetMemberAuditAnswersResponse() {
	yield put(getMemberAuditAnswersChanged());
}

export function* onGetMemberAuditAnswersStart() {
	yield takeLatest(
		AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_START,
		getMemberAuditAnswersStart,
	);
}

export function* onGetMemberAuditAnswersResponseReset() {
	yield takeLatest(
		AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_RESET,
		resetGetMemberAuditAnswersResponse,
	);
}
/** *********************  END GET MEMBER AUDIT ANSWERS ******************** */

export function* reportAuditingToolSaga() {
	yield all([
		call(onGetAuditingToolListDetails),
		call(onGetAuditingToolListResponseReset),
		call(onGetAuditingToolDetailsStart),
		call(onGetAuditingToolDetailsResponseReset),
		call(onGetQuestionnaireDetails),
		call(onGetQuestionnaireResponseReset),
		call(onGetTrainingProposalMembersDetails),
		call(onGetTrainingProposalMembersResponseReset),
		call(onGetTrainingProposalIndividualDetails),
		call(onGetTrainingProposalIndividualResponseReset),
		call(onAddTrainingProposalDetails),
		call(onAddTrainingProposalResponseReset),
		call(onUpdateTrainingProposalDetails),
		call(onUpdateTrainingProposalResponseReset),
		call(onDeleteTrainingProposalDetails),
		call(onDeleteTrainingProposalResponseReset),
		call(onGetAllSuperviserListDetails),
		call(onGetAllSuperviserListResponseReset),
		call(onRejectTrainingProposalDetails),
		call(onRejectTrainingProposalResponseReset),
		call(onSavePhysicalDocsStart),
		call(onSavePhysicalDocsResponseReset),
		call(onSaveDigitalDocsStart),
		call(onSaveDigitalDocsResponseReset),
		call(onReAuditProposalStart),
		call(onReAuditProposalResponseReset),
		call(onGetMemberAuditAnswersStart),
		call(onGetMemberAuditAnswersResponseReset),
	]);
}
